import { Box, Typography } from '@mui/material';

interface TitleParagraphProps {
  title: string;
  paragraph: string;
}

const TitleParagraph: React.FC<TitleParagraphProps> = ({
  title,
  paragraph,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        paddingTop: '16px',
        maxWidth: 1100,
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', sm: '28%' },
          padding: { xs: '16px 16px 0px 16px', sm: '16px 0 0px 20px' },
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'top',
          textAlign: 'left',
        }}
      >
        <Typography variant="h4" component="h4">
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          padding: '16px',
          paddingTop: { xs: '8px', sm: '16px' },
        }}
      >
        <Typography variant="body1" component="p">
          {paragraph}
        </Typography>
      </Box>
    </Box>
  );
};

export default TitleParagraph;
